import React, { useEffect, useState, createContext, useContext } from "react";
// import config from '../../config.json'
import { cssVars } from "../../themes/css-vars.js";
import MantineTheme from "../../themes/mantine.js";
import axios from "axios";

const ConfigContext = createContext();

export const useConfigContext = () => {
   return useContext(ConfigContext);
}

const ConfigContextProvider = ({ children }) => {
   const [jsonTexts, setJsonTexts] = useState({});
   const [jsonMedia, setJsonMedia] = useState({});
   const [jsonColors, setJsonColors] = useState({});
   const [jsonFeatures, setJsonFeatures] = useState({});
   const [jsonFonts, setJsonFonts] = useState({});
   const [jsonBranding, setJsonBranding] = useState({});
   const [theme, setTheme] = useState({});
   const [isReady, setIsReady] = useState(false);


   useEffect(() => {

      const getConfig = async () => {
         try {
            axios.defaults.headers.common['db'] = process.env.REACT_APP_CUSTOMER_NAME;
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}info/configJsonCampus`);
            const config = data.CLIENT_FRONT

            setJsonBranding({
               logo: config.branding.logo,
               logo_sidebar: config.branding.logo_sidebar,
               webUrl: config.branding.webUrl,
               logo_certificate: config.branding.logo_certificate,
               logo_certificate_badge: config.branding.logo_certificate_badge,
               institutionalName: config.branding.institutionalName
            })

            setJsonTexts(config.texts);
            setJsonMedia(config.media);
            setJsonColors(config.colors);
            setJsonFeatures(config.features);
            setJsonFonts(config.typography);

            // set css vars
            const root = document.documentElement;
            cssVars({ root, config })

            const theme = MantineTheme(config.mantine)
            setTheme(theme)
            setIsReady(true)
         } catch (error) {
            console.log(error)
         }
      }

      getConfig()

   }, []);

   return (
      <ConfigContext.Provider value={{
         theme,
         jsonBranding,
         jsonTexts,
         jsonMedia,
         jsonColors,
         jsonFeatures,
         jsonFonts,
         isReady
      }}>
         {children}
      </ConfigContext.Provider>
   );
};
export default ConfigContextProvider;
